module.exports = __webpack_public_path__ + "static/media/logo_nedgia_full.d469bb8b.svg";